import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WorkflowService } from '@services/api/workflow.service';

@Component({
  selector: 'flow-trigger',
  templateUrl: './flow-trigger.component.html',
  styleUrls: ['./flow-trigger.component.scss'],
})
export class FlowTriggerComponent implements OnInit {
  @Output() UpdateTriggerList: EventEmitter<any> = new EventEmitter<any>();
  tempTriggerList: any[] = [];

  constructor(public WFS: WorkflowService) {}

  ngOnInit(): void {
    // Filter the TaskList to only include child triggers
    this.tempTriggerList = this.WFS.TaskList.data?.filter(el => el?.is_child_trigger === true);
  }
  triggerEmitter = eve => {
    // Reset the class of all business rules and workflow to blank
    this.WFS.condition_array.forEach(element => {
      element.class = '';
    });
    this.WFS.action_list.forEach(element => {
      element.class = '';
    });
    // If the selected trigger is a business rule or workflow, set is_submodule to true
    // Otherwise, set the class of the selected trigger to active
    if (eve?.type === 'business_rules' || eve?.type === 'workflow') {
      eve = { ...eve, is_submodule: true };
    } else {
      eve.class = 'active';
    }
    this.UpdateTriggerList.emit(eve);
  };

  FilterSearchTaskList(query: string) {
    // Filter the task list based on the search query
    if (query?.length > 0) {
      this.tempTriggerList = this.WFS.TaskList.data.filter(val => {
        let startsWithCondition = val?.tigger_title?.toLowerCase().startsWith(query.toLowerCase());

        let includesCondition = val?.tigger_title?.toLowerCase().includes(query.toLowerCase());

        if (startsWithCondition) {
          return startsWithCondition;
        } else if (!startsWithCondition && includesCondition) {
          return includesCondition;
        } else return null;
      });
    } else {
      // Reset the task list to its original state
      this.tempTriggerList = this.WFS.TaskList.data;
    }
  }
}
